<template>
  <div v-if="isMobileMenuOpen" class="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
    @click="isMobileMenuOpen = false"></div>
  <div :class="[
    ' z-50 transition-all duration-300',
    isScrolled ? 'fixed top-0 bg-white shadow-md' : ' top-0 left-0 laptop:relative'
  ]">
    <header :class="[
      'mainHeader w-full z-50 transition-all duration-300 mobile:!p-0',
      isScrolled
        ? 'fixed top-0 bg-white shadow-md'
        : 'absolute top-0 left-0 laptop:relative !bg-transparent'
    ]">
      <nav
        class="navbar laptop:h-24 largeDesktop:h-24 mobile:h-auto navbar-expand-lg shadow-md mobile:px-2 largeDesktop:px-3 py-3 px-lg-2 z-10 mobile:rounded-br-[40px] tablet:rounded-br-3xl bg-white">
        <div class="container-fluid">
          <!-- Logo -->
          <a :class="[
            'relative flex items-center rounded-full border-2 shadow-lg border-white p-0 transition-all duration-300 mr-5',
            isScrolled
              ? 'w-10 h-10 laptop:w-20 laptop:h-20 desktop:w-20 desktop:h-20'
              : 'mobile:w-14 mobile:h-14 laptop:w-28 laptop:h-28 largeDesktop:w-36 largeDesktop:h-36 laptop:top-9 largeDesktop:top-11'
          ]">
            <img src="../../../assets/images/fyxifyLogo.png" alt="Logo" class="w-full h-full object-contain">
          </a>
          <div class="flex items-center gap-3">
            <!-- search button for mobile  -->
            <button v-if="!isMobileMenuOpen" @click="toggleSearch" ref="searchButton"
              class="mobile:block laptop:hidden largeDesktop:hidden w-8 h-8 " type="button"
              data-bs-target="#globalSearch" data-bs-toggle="collapse">
              <img :src="searchOpen ? crossIcon : searchIcon" alt="searchicon" class="w-full">
            </button>

            <!-- Toggle Button for Mobile -->
            <button class="navbar-toggler focus:!outline-none focus:!shadow-none collapsed p-0 border-0" type="button"
              aria-label="Toggle navigation" @click="isMobileMenuOpen = !isMobileMenuOpen">
              <!-- <span class="navbar-toggler-icon"></span> -->
              <img v-if="!isMobileMenuOpen" src="../../../assets/images/hamburger-icon.png" alt="Hamburger Icon"
                class="w-8 h-8 object-contain">
              <img v-else src="../../../assets/images/hamburger-times-icon.png" alt="Hamburger Icon"
                class="w-8 h-6 object-contain">
            </button>
          </div>
          <!-- Navbar Content -->
          <div :class="[
            'navbar-collapse mobile:!m-0 laptop:block transition-all duration-300 ease-in-out !ml-5 laptop:min-h-auto laptop:max-h-auto overflow-y-auto custom-scrollbar mobile:max-h-[70vh] mobile:pr-2 tablet:pr-0 tablet:max-h-[auto] px-[0.5rem]',
            isMobileMenuOpen ? 'block bg-white' : 'hidden '
          ]">
            <div class="mobile:flex mobile:flex-col-reverse laptop:flex-row items-center justify-between w-full ">
              <div class="mobile:flex laptop:hidden largeDesktop:hidden items-start gap-5 w-full">
                <sidebarNavigation :setSideMenuClicked="sideMenuClicked" />
                 <!-- <sidebar/> -->
              </div>

              <!-- Left Side Nav -->
              <ul
                class="navbar-nav mobile:w-full mobile:gap-2 mobile:py-3 laptop:w-2/3 largeDesktop:py-0 largeDesktop:me-auto largeDesktop:gap-2 mb-3 mb-lg-0 border-b border-[#EFEFEF] laptop:border-0">
                <li>
                  <a @click="backButton()"
                    class="cursor-pointer w-10 h-10 p-2 rounded-full flex items-center justify-center hidden laptop:!block bg-gradient-to-r from-[#16BCFF] to-[#168EFF]">
                    <img src="../../../assets/images/back-arrow-icon.png" alt="Back Arrow Button" class="w-full h-full">
                  </a>
                </li>
                <li v-for="(item, index) in navItems" :key="index">
                  <component :is="index === 0 ? 'router-link' : 'a'" :to="index === 0 ? item.link : null"
                    @click="isMobileMenuOpen = false" :href="index !== 0 ? item.link : null"
                    :target="index !== 0 ? '_blank' : null" :rel="index !== 0 ? 'noopener noreferrer' : null" :class="[
                      'rounded-full mobile:w-full mobile:block largeDesktop:inline-block',
                      'largeDesktop:px-5 largeDesktop:py-2 tablet:py-1.5 laptop:px-4 mobile:py-1.5 mobile:text-[15px]',
                      'mobile:px-4 py-2.5 no-underline transition-colors !border-0',
                      hoveredIndex === index ? 'text-white cursor-pointer' : 'text-black cursor-pointer'
                    ]" :style="{
                      background: hoveredIndex === index
                        ? 'linear-gradient(to right, #16BCFF, #168EFF)'
                        : '#f3f4f6'
                    }" @mouseover="hoveredIndex = index" @mouseleave="hoveredIndex = null">
                    {{ item.label }}
                  </component>
                </li>
              </ul>

              <!-- Right Side Nav -->
              <div class="flex items-center justify-end mobile:gap-2 mobile:py-0 laptop:w-1/2 laptop:gap-3 w-full">
                <!-- <headerMessage
                  :buttonClass="'inline-flex justify-center items-center w-full rounded-full border font-medium focus:outline-none mobile:px-2 mobile:text-sm laptop:text-base largeDesktop:text-base mobile:gap-1 laptop:px-3 largeDesktop:px-3 py-1 largeDesktop:gap-3 text-gray-800 border-gray-100 bg-gray-100  hover:bg-white '" /> -->

                <!-- Notification Button -->
                <!-- <div class="relative inline-block text-left">
                  <button
                    class="inline-flex justify-center items-center w-full rounded-full border font-medium hover:bg-white focus:outline-none mobile:px-2 mobile:text-sm laptop:text-base largeDesktop:text-base mobile:gap-2 laptop:px-3 laptop:px-3 py-1.5 laptop:gap-3 border-gray-100 bg-gray-100 text-gray-800"
                    @click="notificationModal()">
                    <img src="../../../assets/images/header-notification-icon.png" alt="Notification Icon"
                      class="laptop:w-5 laptop:h-5 mobile:w-5 mobile:h-5 object-contain">
                    <div class="flex gap-1 items-center">
                      <span v-if="notificationCount > 0"
                        class="inline-block mobile:w-1 mobile:h-1 laptop:w-2 laptop:h-2 rounded-full bg-orange-100"></span>
                      <span class="inline-block">{{ notificationCount }}</span>
                    </div>
                  </button>
                </div> -->

                <!-- online offline Switch -->
                <switchSlider @toggle="handleStatusChange" :user="user" />

                <!-- Profile Button -->
                <div class="relative w-14 h-14 flex items-center">
                  <button @click="profileModal()" class="inline-flex justify-center items-center">
                    <img :src="user ? user.user.profile_picture : ''" alt="User Profile Icon"
                      class="mobile:w-11 mobile:h-11 largeDesktop:w-14 largeDesktop:h-14 object-cover rounded-full">
                  </button>
                </div>
              </div>

              <div class="mobile:order-first laptop:hidden">
                <button @click="signoutClicked" type="button"
                  class="mobile:py-1.5 mobile:px-5 tablet:py-1.5 tablet:px-4 largeDesktop:py-2 largeDesktop:px-4 mt-2 mobile:mx-2 tablet:mx-4 mobile:text-base tablet:text-base largeDesktop:text-lg rounded-full no-underline w-max !min-w-[150px] text-[##333333] bg-[#F1F1F1] border-[1px] border-[#E3E3E3]">Sign
                  Out</button>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <!-- search bar  -->
      <div v-if="!isMobileMenuOpen" id="globalSearch" class="navbar-collapse collapse relative z-50">
        <div class="w-full pt-3 px-2 ">
          <globalSearch
            :inputClass="'rounded-full shadow-md pl-3 pr-20 py-3 w-full largeDesktop:h-11 bg-white disabled:!bg-white disabled:opacity-100 focus:outline-none'"
            :buttonclass="'absolute top-[12px] right-2 w-8 h-8'"
            :clearClass="'absolute top-0 flex items-center justify-center !h-[100%] right-[3.2rem] laptop:w-4 laptop:h-4 largeDesktop:w-6 largeDesktop:h-6'"
            :clearable="true" v-model="search" :onEnter="handleSearch" :onClear="handleClear" :readonly="loading" />
        </div>
      </div>
    </header>
  </div>

  <!-- Profile Modal -->
  <div class="modal fade" id="profileModal" ref="profileModal" tabindex="-1" aria-labelledby="profileModal"
    aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:!w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
      <div class="modal-content select-none">
        <div class="modal-body !p-3 !pb-5">
          <div class="relative ">
            <button type="button" class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
              data-bs-dismiss="modal" aria-label="Close">
              <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
            </button>
          </div>
          <div class="">
            <headerUserProfile :openModal="profileModalOpen" :bootme="bootMeUpData" :clickedCallback="clickedCallback"
              :userObject="user" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Notification Modal -->
  <headerNotification :openPopup="openNotificationPopup" />
</template>

<script>
import { Modal } from "bootstrap";
import {
  mapGetters, mapActions
} from "vuex";
import headerMessage from "../../nest_components/header_message.vue";
import headerNotification from "../../nest_components/header_notification.vue";
import headerUserProfile from "../../nest_components/header_profile.vue";
import switchSlider from "../../partialComponent/customSwitchSlider.vue";
import globalSearch from '../../partialComponent/customInput.vue';
import sidebarNavigation from '../../../components/sidebarNavigation.vue';
import showIcon from '../../../assets/images/searchBar-icon.png';
import hideIcon from '../../../assets/images/crossIcon.png';
// import sidebar from "../../nest_components/omega_sidebar/sidebar.vue";
export default {
  components: {
    headerMessage,
    headerNotification,
    headerUserProfile,
    switchSlider,
    globalSearch,
    sidebarNavigation,
    // sidebar
  },
  data() {
    return {
      loading: false,
      search: '',
      isScrolled: false,
      searchIcon: showIcon,
      crossIcon: hideIcon,
      searchOpen: false,
      hoveredIndex: null,
      navItems: [
        { label: 'Dashboard', link: '/protection-plan/nrg/bundle-list' },
        // { label: 'How fyxify works', link: 'https://fyxify.pro/about-us/' },
        { label: 'Contact Us', link: 'https://fyxify.pro/index.html#ContactUs' }
      ],
      isMobileMenuOpen: false, // ← Add this
      profileModalOpen: new Date(),
      user: JSON.parse(localStorage.getItem('user')) ?? null,
      openNotificationPopup: new Date()
    };
  },
  computed: {
    ...mapGetters(["setCompanyInfo", "saveCompanyInfo", "maintenanceBannerData", "bootMeUpData", "userObject", "updateStatusResponse", "signOutResponse", "notificationCountResponse"]),
    notificationCount() {
      return this.notificationCountResponse ? this.notificationCountResponse.unread : 0
    }
  },

  watch: {
    isMobileMenuOpen(newVal) {
      if (newVal) {
        // When menu opens
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      } else {
        // When menu closes
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        this.searchOpen = false;
      }
    },

    updateStatusResponse: function () {
      this.getProfile({})
    },

    userObject: function () {
      this.user = this.userObject
      localStorage.setItem('user', JSON.stringify(this.user))
    },

    bootMeUpData: function () { },

    signOutResponse: function (val) {
      if (val) {
        localStorage.removeItem('user')
        localStorage.removeItem('isSilentLogin')
        localStorage.removeItem('isProtectionPlans')
        localStorage.removeItem('is_from_mobile')
        this.resetSate()
        this.$router.replace({
          name: 'login'
        })
      }
    },

    '$route.query': {
      immediate: true,
      handler(newQuery) {
        if (newQuery) {
          this.search = this.$route.query.q
        }
        
        if (this.$route.name == 'globalSearch') {
          this.$nextTick(() => {
            const isMobile = window.innerWidth < 1024
            const isCollapsed = !document.getElementById('globalSearch')?.classList.contains('show');

            if (isMobile && isCollapsed ) {
              this.$refs.searchButton.click();
            }
          });
        }
      },
    },
  },

  mounted() {
    const is_from_mobile = localStorage.getItem("is_from_mobile", 0) ?? 0
    if (is_from_mobile != '1') {
      this.getProfile({})
      this.getBootMeData({})
    }
    window.addEventListener("scroll", this.handleScroll);
    document.body.style.overflow = 'hidden';
  },
  beforeUnmount() {
    document.body.style.overflow = '';
    window.removeEventListener("scroll", this.handleScroll);
    document.body.style.overflow = '';
  },
  methods: {
    ...mapActions(["getCompanyInfo", "getMaintenanceBannerData", "getBootMeData", "updateStatus", "getProfile", "signOut", "resetSate", "unreadNotificationsCount"]),
    adjustModalHeight() {
      const modalContent = this.$refs.profileModal?.querySelector('.modal-content');
      if (modalContent) {
        const vh = window.innerHeight;
        modalContent.style.maxHeight = `${vh - 40}px`; // adjust padding as needed
        modalContent.style.overflowY = 'auto';
      }
    },

    clickedCallback(option) {
      if (option == 'signout') {
        this.signoutClicked()
      }
    },
    signoutClicked() {
      const originalPadding = document.documentElement.style.padding || '';
      // Remove padding from HTML element
      document.documentElement.style.padding = '0';
      document.documentElement.style.paddingRight = '0';
      this.$confirmDialog.show({
        image:'logout-confirm-icon.svg',
        title: "Sign Out",
        text: "Are you sure you want to sign out?",
        buttonText: "Confirm",
        isShowConfirmText : true,
        // image: "pop-req-img.png",
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.signOut({})
        },
      });
    },

    notificationModal() {
      this.openNotificationPopup = new Date()
    },

    sideMenuClicked() {
      this.isMobileMenuOpen = false
    },
    handleNavClick(item) {
      this.isMobileMenuOpen = false;
      console.log(`Navigating to: ${item.link}`); // item is an object now

      // Collapse any open Bootstrap navbars
      const collapseElements = document.querySelectorAll('.navbar-collapse');
      collapseElements.forEach(el => {
        if (el.classList.contains('show')) {
          new this.Collapse(el).hide();
        }
      });

      // Route to the correct page
      this.$router.push(item.link);
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },

    handleStatusChange(isOnline) {

      this.updateStatus({
        active: isOnline ? '1' : '0',
        lat: '0',
        long: '0',
      })
    },
    toggleSearch() {
      this.searchOpen = !this.searchOpen
    },
    profileModal() {
      const { Modal } = require('bootstrap');
      const modalEl = this.$refs.profileModal;
      this.sideMenuClicked()
      let modal = Modal.getInstance(modalEl);
      if (!modal) {
        modal = new Modal(modalEl, {
          backdrop: 'static',
          keyboard: false
        });
      }
      // Add event listeners for show/hide
      modalEl.addEventListener('show.bs.modal', () => {
        document.documentElement.style.overflow = 'hidden'; // Target HTML element
        if (window.innerWidth >= 992) {
          document.documentElement.style.paddingRight = '15px';
        } else {
          document.documentElement.style.paddingRight = '0px';
        }
        this.adjustModalHeight();
      });
      modalEl.addEventListener('hidden.bs.modal', () => {
        document.documentElement.style.overflow = ''; // Reset HTML element
        document.documentElement.style.paddingRight = '0px';
        window.removeEventListener('resize', this.adjustModalHeight);
        window.removeEventListener('orientationchange', this.adjustModalHeight);
      });

      this.profileModalOpen = new Date()
      // Add orientation/resize responsiveness
      window.addEventListener('resize', this.adjustModalHeight);
      window.addEventListener('orientationchange', this.adjustModalHeight);
      modal.show();
    },
    backButton() {
      this.isMobileMenuOpen = false
      this.$router.go(-1);
    },
    setLoading(){
      this.loading = true
      setTimeout(() => {
          this.loading = false
      }, 200);
    },
    handleClear() {
      this.search = ''
      this.handleSearch()
    },
    handleSearch() {
      let search = ""
      search = this.$helper.isEmpty(this.search) ? '' : this.search.trim()
      this.setLoading()
      if (this.$route.name == 'globalSearch') {
        this.$router.replace({
          name: 'globalSearch',
          query: {
            q: search,
            t: Date.now()
          },
        });
      } else {
        this.$router.push({
          name: 'globalSearch',
          query: {
            q: search,
            t: Date.now()
          },
        });
      }
    }
  }
};
</script>
<style>
@media (max-width: 768px) {

  .collapse:not(.show) {
    display: none;
  }

  .collapse.show {
    display: block;
    height: auto;
    visibility: visible;
  }
}

@media (min-width: 768px) {

  .collapse:not(.show) {
    display: none
  }

  .collapse.show {
    display: block;
    height: auto;
    visibility: visible;
  }
}

a.router-link-active {
  border-bottom: 0 !important;
}
</style>